import { applyPwaDocumentBranding, pwaPngArtwork } from '@next/core-lib/pwa';
import { title_Agrifirm as ar } from 'src/assets/i18n/ar.json';
import { title_Agrifirm as de } from 'src/assets/i18n/de.json';
import { title_Agrifirm as en, title_Agravis } from 'src/assets/i18n/en.json';
import { title_Agrifirm as fr } from 'src/assets/i18n/fr.json';
import { title_Agrifirm as hu } from 'src/assets/i18n/hu.json';
import { title_Agrifirm as nlBE } from 'src/assets/i18n/nl-BE.json';
import { title_Agrifirm as nl } from 'src/assets/i18n/nl.json';
import { title_Agrifirm as pl } from 'src/assets/i18n/pl.json';

const appNames: Record<string, string> = { en, nl, 'nl-BE': nlBE, fr, de, pl, hu, ar };

export function getPwaLocale(locale = 'en'): string {
  const normalized = locale.toLowerCase();
  return (
    Object.keys(appNames).find((key) => key.toLowerCase() === normalized) ??
    (Object.prototype.hasOwnProperty.call(appNames, normalized.split('-')[0])
      ? normalized.split('-')[0]
      : 'en')
  );
}

export function getPwaAppName(tenant?: string, locale?: string): string {
  return tenant === 'Agravis' ? title_Agravis : appNames[getPwaLocale(locale)];
}

export function getPwaFaviconUrl(tenant?: string): string {
  return tenant === 'Agravis'
    ? '/assets/pwa/avidata-favicon-96.png'
    : '/assets/images/poultry-next-logo.svg';
}

export function applyPwaBranding(document: Document, tenant?: string, locale?: string): void {
  const agravis = tenant === 'Agravis';
  applyPwaDocumentBranding(document, {
    manifestUrl: agravis
      ? '/assets/manifest-agravis.webmanifest'
      : `/assets/manifest_${getPwaLocale(locale)}.json`,
    appName: getPwaAppName(tenant, locale),
    themeColor: agravis ? '#65b32e' : '#007f2d',
    ...(agravis
      ? pwaPngArtwork('/assets/pwa/avidata')
      : {
          icons: [
            { href: '/assets/images/poultry-next-logo.svg', sizes: 'any', type: 'image/svg+xml' },
          ],
          appleTouchIcon: '/assets/icons/apple-icon-180x180.png',
        }),
    legacyTileImage: null,
  });
}
